import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-cream px-4 py-8 sm:px-8 sm:py-12" data-id="element-139" data-mp="1dqrohw3lfk7t">
      <div className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="3r9ap7f7ufjz7">
        <p className="font-display text-base font-extrabold text-ink-900 sm:text-lg" data-id="element-141" data-mp="3ralvpmsob5u0">
          Mega Pack Adolescencia Integral
        </p>
        <p className="mt-2 font-sans text-xs leading-relaxed text-ink-600 sm:mt-3 sm:text-sm" data-id="element-142" data-mp="3hheqq31uhrug">
          Un recurso práctico para docentes, tutores y equipos educativos que
          trabajan con adolescentes y quieren dejar de preparar cada clase desde
          cero.
        </p>
        <p className="mt-4 font-sans text-[11px] text-ink-600 sm:mt-6 sm:text-xs" data-id="element-143" data-mp="33i59d01wkrow">
          © 2026 — Todos los derechos reservados
        </p>

        <div className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-sans text-[11px] text-ink-600 sm:text-xs" data-id="element-144" data-mp="2yl57l1c36b3l">
          <a href="mailto:armatedigitalsoporte@gmail.com" className="underline decoration-cream-300 underline-offset-2 transition-colors duration-150 ease-out hover:text-ink-900" data-id="element-145" data-mp="ws7gb9xyjqkr">
            armatedigitalsoporte@gmail.com
          </a>
          <a href="https://instagram.com/armate_digital" target="_blank" rel="noopener noreferrer" className="underline decoration-cream-300 underline-offset-2 transition-colors duration-150 ease-out hover:text-ink-900" data-id="element-146" data-mp="1anvf1d203q7d">
            @armate_digital
          </a>
        </div>
      </div>
    </footer>;
}